import { DateTime } from 'luxon';
import { VendorCatalogItem } from '../../../../Lib/Hooks/ItemService/types';
import { ItemDetailsFormData } from './types';

export function mapTargetItemToFormValues(
  targetItem?: VendorCatalogItem,
): ItemDetailsFormData {
  if (!targetItem) {
    return {
      styleNumber: null,
      jrVendorReference: null,
      plusVendorReference: null,
      division: null,
      department: null,
      category: null,
      class: null,
      detail1: [],
      detail2: null,
      detail3: null,
      fashionnovaExclusive: false,
      incoterm: null,
      countryOfOrigin: null,
      shipmentMode: null,
      leadTime: null,
      reorderLeadTime: null,
      cancelDate: null,
      moq: null,
      mcq: null,
      stockQuantity: null,
      stockRatio: null,
      stockIhd: null,
      incomingStockQuantity: null,
      incomingStockRatio: null,
      incomingStockDate: null,
      length: null,
      inseam: null,
      stretch: null,
      neckline: null,
      sleeveLength: null,
      topLength: null,
      bodyFitTop: null,
      bodyFitBottom: null,
      bottomLength: null,
      fabricWeight: null,
      fabricCode: null,
      fabric: null,
      patternPrint: null,
      wash: null,
      heelHeight: null,
      heelType: null,
      shoeStyle: null,
    };
  }

  return {
    styleNumber: targetItem.style_number ?? null,
    jrVendorReference: targetItem.jr_vendor_ref ?? null,
    plusVendorReference: targetItem.plus_vendor_ref ?? null,
    division: targetItem.division ?? null,
    department: targetItem.department ?? null,
    category: targetItem.category ?? null,
    class: targetItem.class ?? null,
    detail1: targetItem.detail_1 ?? [],
    detail2: targetItem.detail_2 ?? null,
    detail3: targetItem.detail_3 ?? null,
    fashionnovaExclusive: targetItem.fashionnova_exclusive ?? false,
    incoterm: targetItem.draft_purchase_order?.incoterm ?? null,
    countryOfOrigin: targetItem.draft_purchase_order?.country_of_origin ?? null,
    shipmentMode: targetItem.draft_purchase_order?.shipment_mode ?? null,
    leadTime: targetItem.lead_time_in_weeks ?? null,
    reorderLeadTime: targetItem.reorder_lead_time_in_weeks ?? null,
    cancelDate: targetItem.draft_purchase_order?.due_date
      ? DateTime.fromJSDate(
          new Date(targetItem.draft_purchase_order?.due_date),
          {
            zone: 'utc',
          },
        ).toISODate()
      : null,
    moq: targetItem.moq ?? null,
    mcq: targetItem.mcq ?? null,
    stockQuantity: targetItem.stock_quantity ?? null,
    stockRatio: targetItem.stock_ratio ?? null,
    stockIhd: targetItem.stock_ihd
      ? DateTime.fromJSDate(new Date(targetItem.stock_ihd), {
          zone: 'utc',
        }).toISODate()
      : null,
    incomingStockQuantity: targetItem.incoming_stock_quantity ?? null,
    incomingStockRatio: targetItem.incoming_stock_ratio ?? null,
    incomingStockDate: targetItem.incoming_stock_date
      ? DateTime.fromJSDate(new Date(targetItem.incoming_stock_date), {
          zone: 'utc',
        }).toISODate()
      : null,
    length: targetItem.length ?? null,
    inseam: targetItem.inseam ?? null,
    stretch: targetItem.stretch ?? null,
    neckline: targetItem.neckline ?? null,
    sleeveLength: targetItem.sleeve_length ?? null,
    topLength: targetItem.top_length ?? null,
    bodyFitTop: targetItem.body_fit_top ?? null,
    bodyFitBottom: targetItem.body_fit_bottom ?? null,
    bottomLength: targetItem.bottom_length ?? null,
    fabricWeight: targetItem.fabric_weight ?? null,
    fabricCode: targetItem.fabric_code_and_name ?? null,
    fabric: targetItem.fabric ?? null,
    patternPrint: targetItem.pattern_print ?? null,
    wash: targetItem.wash ?? null,
    heelHeight: targetItem.heel_height ?? null,
    heelType: targetItem.heel_type ?? null,
    shoeStyle: targetItem.shoe_style ?? null,
  };
}
